import React, { useReducer, createContext } from 'react';
import { client } from '../utils/storefront-client';

export const defaultStoreContext = {
  client,
  adding: false,
  checkout: { lineItems: [] },
  products: [],
  shop: {},
  filteredType: 'all',
  filteredSort: 'featured',
  customerAccessToken: null,
  setValue: () => { },
  addVariantToCart: () => { },
  addVariantToCartAndBuyNow: () => { },
  removeLineItem: () => { },
  updateLineItem: () => { },
};

const StoreContext = createContext(defaultStoreContext);

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_CHECKOUT':
      return { ...state, checkout: action.payload };
    default:
      return state;
  }
};

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, defaultStoreContext);

  const updateLineItem = async (cartId, lineItemId, quantity) => {
    const { updateLineItems } = await import('../utils/storefront-client');
    const lineItemsToUpdate = [{ id: lineItemId, quantity: parseInt(quantity, 10) }];
    const checkout = await updateLineItems(cartId, lineItemsToUpdate);
    dispatch({ type: 'SET_CHECKOUT', payload: checkout });
  };

  return (
    <StoreContext.Provider value={{ ...state, updateLineItem }}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreContext;
